import loginRequired from '@middlewares/loginRequired';

export default [
  {
    path: 'mypage',
    name: 'artist.mypage.index',
    meta: {
      middleware: loginRequired
    },
    component: () => import('@pages/mypage/MyPage')
  },
  {
    path: 'change-password',
    name: 'artist.mypage.change-password',
    meta: {
      middleware: loginRequired
    },
    component: () => import('@pages/mypage/ChangePassword')
  },
  {
    path: 'mypage-edit',
    name: 'artist.mypage.edit',
    meta: {
      middleware: loginRequired
    },
    component: () => import('@pages/mypage/MyPageEdit')
  },
  {
    path: 'mypage-confirmation',
    name: 'artist.mypage.confirmation',
    meta: {
      middleware: loginRequired
    },
    component: () => import('@pages/mypage/MyPageConfirmation')
  },
  {
    path: 'mypage-cancel',
    name: 'artist.mypage.cancel',
    meta: {
      middleware: loginRequired
    },
    component: () => import('@pages/mypage/MyPageCancel')
  },
  {
    path: 'mypage-cancel-fix',
    name: 'artist.mypage.cancel.fix',
    meta: {
      middleware: loginRequired
    },
    component: () => import('@pages/mypage/MyPageCancelFix')
  },
  {
    path: 'mypage-history',
    name: 'artist.mypage.purchase_history',
    meta: {
      middleware: loginRequired
    },
    component: () => import('@pages/mypage/MyPageHistory')
  },
  {
    path: 'mypage-history/:history_id',
    name: 'artist.mypage.history_detail',
    meta: {
      middleware: loginRequired
    },
    component: () => import('@pages/mypage/MyPageHistoryDetail')
  },
]
